const StandartDynamicPageContainer = () =>
  import('@/views/containers/StandartDynamicPageContainer/StandartDynamicPageContainer.vue');
const CatalogView = () => import('@/views/Catalog/Products/Products.vue');
const ProductDetailView = () => import('@/components/products/ProductDetail/ProductDetail.vue');

export const basicRoutes = {
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'inicio',
      component: StandartDynamicPageContainer,
      props: {
        idSubSection: 5,
      },
    },
    {
      path: '/nosotros',
      name: 'nosotros',
      component: () => import('./views/About/About.vue'),
    },
    {
      path: '/catalogos',
      name: 'catalogos',
      component: () => import('./views/Publications/Publications.vue'),
    },
    {
      path: '/reclamo',
      name: 'reclamo',
      component: () => import('./views/Claims/Claims.vue'),
    },
    {
      path: '/catalogos-ofertas/:cate?/:subcate?',
      name: 'catalogos-ofertas',
      component: () => import('./views/Offers/Offers.vue'),
    },
    {
      path: '/404',
      name: '404',
      component: () => import('./views/404/404.vue'),
    },
    {
      path: '/Timeout',
      name: 'Timeout',
      component: () => import('./views/Timeout/Timeout.vue'),
    },
    {
      path: '/pruebaChatbot',
      name: 'pruebaChatbot',
      component: () => import('./views/PruebaChatbot/PruebaChatbot.vue'),
    },
    {
      path: '*',
      component: () => import('./views/404/404.vue'),
    },
  ],
};

export const accountRoutes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/login/login.vue'),
  },
  {
    path: '/registrar',
    name: 'registrar',
    component: () => import('./views/Register/Register.vue'),
  },
  {
    path: '/reset-pass',
    name: 'reset-pass',
    component: () => import('./views/ResetPass/ResetPass.vue'),
  },
  {
    path: '/enable-client/:email',
    name: 'enable-client',
    component: () => import('./views/EnableClient/EnableClient.vue'),
  },
  {
    path: '/perfil',
    name: 'perfil',
    component: () => import('./views/Profile/Profile.vue'),
  },
];

export const ecommerceRoutes = [
  {
    path: '/tracking',
    name: 'tracking',
    component: () => import('./views/Tracking/Tracking.vue'),
  },
  {
    path: '/productos/:crit?/:page?/:cate?/:subcate?/:caliber?/:brand?/:query?',
    name: 'productos',
    component: CatalogView,
  },
  {
    path: '/producto/:id',
    name: 'detalle-productos',
    component: ProductDetailView,
  },
  {
    path: '/carrito',
    name: 'carrito',
    component: () => import('./components/products/cart/CartProducts/CartProducts.vue'),
    beforeEnter: (to, from, next) => {
      next();
    },
  },
  {
    path: '/datos-compra',
    name: 'datos-compra',
    component: () => import('./components/products/cart/CartProducts-3/CartProducts-3.vue'),
    beforeEnter: (to, from, next) => {
      next();
    },
  },
  {
    path: '/resumen',
    name: 'resumen',
    component: () => import('./components/products/cart/CartProducts-4/CartProducts-4.vue'),
    beforeEnter: (to, from, next) => {
      next();
    },
  },
  {
    path: '/visa-final/:token',
    name: 'visa-final',
    component: () => import('./components/products/cart/visa-final/visa-final.vue'),
    beforeEnter: (to, from, next) => {
      next();
    },
  },
  {
    path: '/pago',
    name: 'pago',
    component: () => import('./components/checkout/CheckoutPayment/CheckoutPayment.vue'),
  },
  {
    path: '/pedidos',
    name: 'pedidos',
    component: () => import('./views/Orders/Orders.vue'),
  },
  {
    path: '/seguimiento/:id?',
    name: 'seguimiento',
    component: () => import('./views/Orders2/Orders2.vue'),
  },
  {
    path: '/confirmacion',
    name: 'confirmacion',
    component: () => import('./views/Confirmation/Confirmation.vue'),
  },
];

export const getDynamicRoutes = (seccionList) => {
  let dynamicRoutes = [];
  seccionList.forEach(function(section) {
    const idSection = section.cod_section;
    if (!(idSection == 2)) {
      let idSubSection = section.sub_sections[0].cod_sub_section;
      var dynamicRoute = {
        path:
          idSection === 4 || idSection === 8
            ? '/' + section.url_es + '/:id?'
            : '/' + section.url_es,
        name: section.url_es,
        component: StandartDynamicPageContainer,
        props: {
          idSubSection: idSubSection,
        },
      };
      dynamicRoutes.push(dynamicRoute);
    }
  });
  return dynamicRoutes;
};
